//CSS
import "../../Components/Page/Page.css";
import "./Goals.css";
import engine2 from "../../Images/Discover/old_engin_schimatics_mid.png";
import engine from "../../Images/ElfTech/Engine One.png";

//React
import React from "react";
import SecHeader from "../../Components/SecHeader/SecHeader";
import SubSection from "../../Components/Section/SubSection";
import ImageComp from "../../Components/ImageContainer/ImageComp";
import { Link } from "react-router-dom";

const Goals: React.FC = () => {
  return (
    <div className="sectionContainer">
      <SecHeader title="Goals" />
      <SubSection>
        <ImageComp imageSource={engine2} width={"Clamp(18rem, 25vw, 36rem)"} />
        <div className="description-container">

          <b>Revolutionizing Engines for a Sustainable Future</b>
          <p>
            We conducted research on all engines and designs, to determine why they are inefficient
            and harmful to the environment.
          </p>{" "}
          <p>
            We developed the engines – size, power, efficiency calculator {" "}
            <Link to="../products-protected">(E-SPEC™)</Link> or and new efficient,
            light, flex-fuel technology {" "}
            <Link to="../products">(ELF-Tech™)</Link> designs that result in better efficiency, emissions,
            fuel flexibility and power-to-weight.
          </p>{" "}
        </div>
      </SubSection>
      <SubSection >
        <ImageComp imageSource={engine} width={"Clamp(18rem, 25vw, 36rem)"} />
        <div className="description-container">
          <b>Selling Licenses for ELF-Tech Designs</b>
          <p>
            Now ICEGEMS offers licenses for ELF-TECH designs which fit your needs and specs. {" "}
            <Link to="../wankel">Wankel</Link> profited
            from licensing his new geometries last century and our goal is to surpass him with our new
            geometries within the next decade. Imagine a new generation of engines, more fuel-efficient and
            powerful, lighter, cleaner, easier to manufacture, longer-lasting,
            cheaper to run, fix and recycle, and capable of running on multiple
            fuel types.
          </p>
        </div>

      </SubSection>
    </div>
  );
};

export default Goals;
